// extracted by mini-css-extract-plugin
export default {"Link":"Link-module__Link--VHHyP","Icon":"Link-module__Icon--Z2ro6"};